import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7092/Proposals";
	}
	archiveProposal(e, t) {
		let r = this.baseUrl + "/ArchiveProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processArchiveProposal(e)));
	}
	processArchiveProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	createPrivateSectionTemplate(e, t) {
		let r = this.baseUrl + "/CreatePrivateSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreatePrivateSectionTemplate(e)));
	}
	processCreatePrivateSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	createProposal(e, t) {
		let r = this.baseUrl + "/CreateProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateProposal(e)));
	}
	processCreateProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteProposal(e, t) {
		let r = this.baseUrl + "/DeleteProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteProposal(e)));
	}
	processDeleteProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	duplicateProposal(e, t) {
		let r = this.baseUrl + "/DuplicateProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDuplicateProposal(e)));
	}
	processDuplicateProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getProposal(e, t) {
		let r = this.baseUrl + "/GetProposal";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'proposalId' must be defined and cannot be null.");
		r += "proposalId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetProposal(e)));
	}
	processGetProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getRenderContext(e, t) {
		let r = this.baseUrl + "/GetRenderContext";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'proposalId' must be defined and cannot be null.");
		r += "proposalId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetRenderContext(e)));
	}
	processGetRenderContext(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? H("No description", e.status, e.data, t) : e.status === 404 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	insertPublishedSectionTemplate(e, t) {
		let r = this.baseUrl + "/InsertPublishedSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processInsertPublishedSectionTemplate(e)));
	}
	processInsertPublishedSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	listProposals(e, t) {
		let r = this.baseUrl + "/ListProposals";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'agencyIds' cannot be null.");
		if (e !== void 0) for (let t of e) r += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processListProposals(e)));
	}
	processListProposals(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	listPublishedProposalTemplates(e, t, r, i) {
		let a = this.baseUrl + "/ListPublishedProposalTemplates";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'subjectType' must be defined and cannot be null.");
		a += "subjectType=" + encodeURIComponent(f(e)) + "&", t != null && (a += "hasAddress=" + encodeURIComponent(f(t)) + "&"), r != null && (a += "hasJurisdiction=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processListPublishedProposalTemplates(e)));
	}
	processListPublishedProposalTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	listSectionTemplates(e, t, r, i) {
		let a = this.baseUrl + "/ListSectionTemplates";
		if (a += "?", e === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
		if (e !== void 0 && (a += "status=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'scope' cannot be null.");
		if (t !== void 0 && (a += "scope=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		r !== void 0 && (a += "agencyId=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processListSectionTemplates(e)));
	}
	processListSectionTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	saveProposal(e, t) {
		let r = this.baseUrl + "/SaveProposal", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSaveProposal(e)));
	}
	processSaveProposal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffArchiveProposalTemplate(e, t, r) {
		let i = this.baseUrl + "/StaffArchiveProposalTemplate";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
		i += "templateId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffArchiveProposalTemplate(e)));
	}
	processStaffArchiveProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffArchiveSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffArchiveSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffArchiveSectionTemplate(e)));
	}
	processStaffArchiveSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffArchiveThemeSet(e, t, r) {
		let i = this.baseUrl + "/StaffArchiveThemeSet";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		i += "id=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffArchiveThemeSet(e)));
	}
	processStaffArchiveThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateProposalTemplate(e, t) {
		let r = this.baseUrl + "/StaffCreateProposalTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffCreateProposalTemplate(e)));
	}
	processStaffCreateProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffCreateSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffCreateSectionTemplate(e)));
	}
	processStaffCreateSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffCreateThemeSet(e, t) {
		let r = this.baseUrl + "/StaffCreateThemeSet", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffCreateThemeSet(e)));
	}
	processStaffCreateThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffDuplicateProposalTemplate(e, t) {
		let r = this.baseUrl + "/StaffDuplicateProposalTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffDuplicateProposalTemplate(e)));
	}
	processStaffDuplicateProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffDuplicateThemeSet(e, t, r) {
		let i = this.baseUrl + "/StaffDuplicateThemeSet";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		i += "id=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffDuplicateThemeSet(e)));
	}
	processStaffDuplicateThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffListFonts(e) {
		let t = this.baseUrl + "/StaffListFonts", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffListFonts(e)));
	}
	processStaffListFonts(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffListProposalTemplates(e, t, r, i) {
		let a = this.baseUrl + "/StaffListProposalTemplates";
		if (a += "?", e === null) throw new globalThis.Error("The parameter 'status' cannot be null.");
		if (e !== void 0 && (a += "status=" + encodeURIComponent(f(e)) + "&"), t === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (t !== void 0 && (a += "agencyId=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'search' cannot be null.");
		r !== void 0 && (a += "search=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processStaffListProposalTemplates(e)));
	}
	processStaffListProposalTemplates(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffListThemeSets(e, t) {
		let r = this.baseUrl + "/StaffListThemeSets";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
		e !== void 0 && (r += "includeArchived=" + encodeURIComponent(f(e)) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffListThemeSets(e)));
	}
	processStaffListThemeSets(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffPublishProposalTemplate(e, t, r) {
		let i = this.baseUrl + "/StaffPublishProposalTemplate";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
		i += "templateId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "POST",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffPublishProposalTemplate(e)));
	}
	processStaffPublishProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffPublishSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffPublishSectionTemplate", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffPublishSectionTemplate(e)));
	}
	processStaffPublishSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateProposalTemplate(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateProposalTemplate";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'templateId' must be defined and cannot be null.");
		i += "templateId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateProposalTemplate(e)));
	}
	processStaffUpdateProposalTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateSectionTemplate(e, t) {
		let r = this.baseUrl + "/StaffUpdateSectionTemplate", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateSectionTemplate(e)));
	}
	processStaffUpdateSectionTemplate(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateThemeSet(e, t, r) {
		let i = this.baseUrl + "/StaffUpdateThemeSet";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
		i += "id=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffUpdateThemeSet(e)));
	}
	processStaffUpdateThemeSet(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 || e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUploadFont(e, t) {
		let r = this.baseUrl + "/StaffUploadFont", i = new FormData();
		for (let [t, n] of Object.entries(e ?? {})) n != null && i.append(t, n instanceof Blob ? n : String(n));
		let a = {
			method: "POST",
			url: r,
			headers: { Accept: "application/json" },
			data: i,
			signal: t
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUploadFont(e)));
	}
	processStaffUploadFont(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 403 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateGenericSubject(e, t) {
		let r = this.baseUrl + "/UpdateGenericSubject", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateGenericSubject(e)));
	}
	processUpdateGenericSubject(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? H("Payload of ProposalErrorResponse", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Normal = "Normal", e.Italic = "Italic", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Percentage = "Percentage", e.FlatFee = "FlatFee", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.PrivateTreaty = "PrivateTreaty", e.Auction = "Auction", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Search = "Search", e.Manual = "Manual", e.AttachAsFile = "AttachAsFile", e.NotAvailable = "NotAvailable", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Text = "Text", e.Textarea = "Textarea", e.RichText = "RichText", e.Number = "Number", e.Currency = "Currency", e.Boolean = "Boolean", e.Select = "Select", e.Color = "Color", e.Image = "Image", e.Video = "Video", e.Asset = "Asset", e.Date = "Date", e.Repeater = "Repeater", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.PlainText = "PlainText", e.RichText = "RichText", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Listing = "Listing", e.Generic = "Generic", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Shared = "Shared", e.Accepted = "Accepted", e.Superseded = "Superseded", e.Archived = "Archived", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Ready = "Ready", e.Deferred = "Deferred", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Intro = "Intro", e.AgentProfile = "AgentProfile", e.Appraisal = "Appraisal", e.Cma = "Cma", e.RecentSales = "RecentSales", e.PropertyGallery = "PropertyGallery", e.MarketingQuote = "MarketingQuote", e.Fees = "Fees", e.Testimonials = "Testimonials", e.CallToAction = "CallToAction", e.AttachmentPdf = "AttachmentPdf", e.Freeform = "Freeform", e.CustomHtml = "CustomHtml", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.Standalone = "Standalone", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Compact = "Compact", e.Comfortable = "Comfortable", e.Editorial = "Editorial", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Standard = "Standard", e.Wide = "Wide", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Platform = "Platform", e.Agency = "Agency", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.Platform = "Platform", e.Agency = "Agency", e.PrivateAgent = "PrivateAgent", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.Normal = "Normal", e.Italic = "Italic", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.Draft = "Draft", e.Published = "Published", e.Archived = "Archived", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.Standalone = "Standalone", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.Active = "Active", e.Archived = "Archived", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.SingleRate = "SingleRate", e.MultiRate = "MultiRate", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), V = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isProposalsApiException = !0;
	static isProposalsApiException(e) {
		return e.isProposalsApiException === !0;
	}
};
function H(e, t, n, r, i) {
	throw i ?? new V(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var U = "proposals";
function W(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var G = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), W(r);
}, K = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[U] || `${e}/${U}`;
}, q = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = K(i), u = c, d = G(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = G(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, J = a({}), Y = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = q(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(J.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, X = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.archiveProposal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		archiveProposal: u,
		archiveProposalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Z = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createPrivateSectionTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createPrivateSectionTemplate: u,
		createPrivateSectionTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createProposal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createProposal: u,
		createProposalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ne = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.deleteProposal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		deleteProposal: u,
		deleteProposalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, re = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.duplicateProposal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		duplicateProposal: u,
		duplicateProposalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ie = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getProposal", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getProposal(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getProposal", e] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getRenderContext", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getRenderContext(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getRenderContext", e] });
	}, e[0] = t, e[1] = n), n;
}, ce = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.insertPublishedSectionTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		insertPublishedSectionTemplate: u,
		insertPublishedSectionTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, le = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["listProposals", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.listProposals(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["listProposals", e] });
	}, e[0] = t, e[1] = n), n;
}, de = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(J), l;
	a[0] !== t || a[1] !== n || a[2] !== e ? (l = [
		"listPublishedProposalTemplates",
		e,
		t,
		n
	], a[0] = t, a[1] = n, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== t || a[6] !== n || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.listPublishedProposalTemplates(e, t, n, i);
	}, a[4] = c, a[5] = t, a[6] = n, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"listPublishedProposalTemplates",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(J), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"listSectionTemplates",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== n || a[5] !== c || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.listSectionTemplates(e, t, n, i);
	}, a[4] = n, a[5] = c, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"listSectionTemplates",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, he = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.saveProposal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		saveProposal: u,
		saveProposalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ge = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { templateId: t, body: n } = e;
		return a.staffArchiveProposalTemplate(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffArchiveProposalTemplate: u,
		staffArchiveProposalTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, _e = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffArchiveSectionTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffArchiveSectionTemplate: u,
		staffArchiveSectionTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ve = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { id: t, body: n } = e;
		return a.staffArchiveThemeSet(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffArchiveThemeSet: u,
		staffArchiveThemeSetPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ye = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffCreateProposalTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffCreateProposalTemplate: u,
		staffCreateProposalTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, be = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffCreateSectionTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffCreateSectionTemplate: u,
		staffCreateSectionTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, xe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffCreateThemeSet(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffCreateThemeSet: u,
		staffCreateThemeSetPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Se = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffDuplicateProposalTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffDuplicateProposalTemplate: u,
		staffDuplicateProposalTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ce = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { id: t, body: n } = e;
		return a.staffDuplicateThemeSet(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffDuplicateThemeSet: u,
		staffDuplicateThemeSetPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, we = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffListFonts"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffListFonts(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Te = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffListFonts"] });
	}, e[0] = t, e[1] = n), n;
}, Ee = (e, t, n, i) => {
	let a = r(17), s = i === void 0 || i, c = o(J), l;
	a[0] !== t || a[1] !== n || a[2] !== e ? (l = [
		"staffListProposalTemplates",
		e,
		t,
		n
	], a[0] = t, a[1] = n, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== t || a[5] !== c || a[6] !== n || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.staffListProposalTemplates(e, t, n, i);
	}, a[4] = t, a[5] = c, a[6] = n, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, De = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"staffListProposalTemplates",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, $ = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["staffListThemeSets", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffListThemeSets(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffListThemeSets", e] });
	}, e[0] = t, e[1] = n), n;
}, ke = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { templateId: t, body: n } = e;
		return a.staffPublishProposalTemplate(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffPublishProposalTemplate: u,
		staffPublishProposalTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ae = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffPublishSectionTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffPublishSectionTemplate: u,
		staffPublishSectionTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, je = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { templateId: t, body: n } = e;
		return a.staffUpdateProposalTemplate(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateProposalTemplate: u,
		staffUpdateProposalTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Me = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUpdateSectionTemplate(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateSectionTemplate: u,
		staffUpdateSectionTemplatePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ne = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { id: t, body: n } = e;
		return a.staffUpdateThemeSet(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUpdateThemeSet: u,
		staffUpdateThemeSetPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Pe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffUploadFont(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffUploadFont: u,
		staffUploadFontPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Fe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(J), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateGenericSubject(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateGenericSubject: u,
		updateGenericSubjectPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { m as AgencyFontStyle, h as FlatCommissionType, g as GenericSubjectUpdateRequestJurisdiction, _ as LandAreaDetailsTotalLandAreaType, v as ListingSaleDetailsSaleType, y as PropertyDetailsBuiltOnOrVacantLandType, b as PropertyDetailsRuralType, x as ProposalCmaValuesComparativeType, S as ProposalFieldDefinitionType, C as ProposalInlineEditingMode, w as ProposalPropertyValuesJurisdiction, ee as ProposalResponseProposalType, te as ProposalResponseStatus, T as ProposalSectionAvailabilityStatus, E as ProposalSectionType, D as ProposalSubjectJurisdiction, O as ProposalSubjectRequestJurisdiction, k as ProposalSubjectRequestType, A as ProposalThemeLayoutDensity, j as ProposalThemeLayoutPageWidth, J as ProposalsApiContext, V as ProposalsApiException, Y as ProposalsApiProvider, p as ProposalsClient, U as ProposalsRoute, M as PublishedProposalTemplateResponseScope, N as Scope, P as StaffUploadFontFormStyle, F as Status, I as SubjectType, L as ThemeSetResponseStatus, R as TieredCommissionTieredSystemType, z as UploadedDocumentDocumentType, B as VendorChoiceValueType, X as useArchiveProposal, Z as useCreatePrivateSectionTemplate, Q as useCreateProposal, ne as useDeleteProposal, re as useDuplicateProposal, ie as useGetProposal, oe as useGetRenderContext, ce as useInsertPublishedSectionTemplate, ae as useInvalidateUseGetProposal, se as useInvalidateUseGetRenderContext, ue as useInvalidateUseListProposals, fe as useInvalidateUseListPublishedProposalTemplates, me as useInvalidateUseListSectionTemplates, Te as useInvalidateUseStaffListFonts, De as useInvalidateUseStaffListProposalTemplates, Oe as useInvalidateUseStaffListThemeSets, le as useListProposals, de as useListPublishedProposalTemplates, pe as useListSectionTemplates, q as useProposalsClientContext, he as useSaveProposal, ge as useStaffArchiveProposalTemplate, _e as useStaffArchiveSectionTemplate, ve as useStaffArchiveThemeSet, ye as useStaffCreateProposalTemplate, be as useStaffCreateSectionTemplate, xe as useStaffCreateThemeSet, Se as useStaffDuplicateProposalTemplate, Ce as useStaffDuplicateThemeSet, we as useStaffListFonts, Ee as useStaffListProposalTemplates, $ as useStaffListThemeSets, ke as useStaffPublishProposalTemplate, Ae as useStaffPublishSectionTemplate, je as useStaffUpdateProposalTemplate, Me as useStaffUpdateSectionTemplate, Ne as useStaffUpdateThemeSet, Pe as useStaffUploadFont, Fe as useUpdateGenericSubject };
